import type { GridInitialState } from "@mui/x-data-grid-premium";

export const hideIdColumnInInitialState = (
  initialState: GridInitialState | undefined,
) => {
  if (initialState?.columns?.columnVisibilityModel?.["id"] == null) {
    return {
      ...initialState,
      columns: {
        ...initialState?.columns,
        columnVisibilityModel: {
          ...initialState?.columns?.columnVisibilityModel,
          id: false,
        },
      },
    };
  }
  return initialState;
};
